import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  '& #social-proof-alt-title': {
    color: colors.primary
  },
  '& #social-proof-title': {
    color: colors.secondary
  },
  '& #social-proof-slot-title': {
    color: colors.secondary
  },
  '& #social-proof-slot-description': {
    color: colors.secondary
  },
  '& #hero-map-circle': {
    backgroundColor: colors.primary,
  },
  background: `linear-gradient(-45deg, ${colors.black}, ${colors.secondary}, ${colors.black}, ${colors.secondary})`,
    backgroundSize: '400% 400%',
	  // animation: 'gradient 10s ease infinite',
    '& #hero-title': {
      color: colors.tertiary
    },
    '& #hero-subtitle': {
      color: colors.tertiary
    },
    // '@keyframes gradient': {
    //   '0%': {
    //     backgroundPosition: '0% 50%'
    //   },
    //   '50%': {
    //     backgroundPosition: '100% 50%'
    //   },
    //   '100%': {
    //     backgroundPosition: '0% 50%'
    //   }
    // }
};

const hero2Styles: any = (theme?: Theme) => styles;

export default hero2Styles;